export type AppLovinAdUnitIds = {
  rewarded: string;
  interstitial: string;
  banner: string;
};

export type AppLovinConfig = {
  sdk_key: string;
  ad_unit_ids: AppLovinAdUnitIds;
  privacy_policy_url: string;
  terms_of_service_url: string;
  test_mode: boolean;
  test_device_advertising_ids: string[];
};

// MAX ad units are per platform (dashboard → Ad Units → filter by package + iOS/Android).
const AD_UNIT_IDS_BY_PLATFORM: Record<'android' | 'ios', AppLovinAdUnitIds> = {
  android: {
    rewarded: 'f99d0c3b1ab3555d',
    interstitial: '7731dd20c1cc48cb',
    banner: 'TODO_APPLOVIN_BANNER_AD_UNIT_ID',
  },
  ios: {
    rewarded: 'fb435442665c0292',
    interstitial: 'ee0ccb1a49bd97be',
    banner: 'TODO_APPLOVIN_IOS_BANNER_AD_UNIT_ID',
  },
};

function currentPlatformAdUnitIds(): AppLovinAdUnitIds
{
  const platform = ( window as any ).Capacitor?.getPlatform?.();
  return platform === 'ios' ? AD_UNIT_IDS_BY_PLATFORM.ios : AD_UNIT_IDS_BY_PLATFORM.android;
}

export const APPLOVIN_CONFIG: AppLovinConfig = {
  sdk_key: 'TODO_APPLOVIN_SDK_KEY',
  ad_unit_ids: currentPlatformAdUnitIds(),
  privacy_policy_url: 'https://match-star.com/policy.html',
  terms_of_service_url: '',
  test_mode: false,
  test_device_advertising_ids: [],
};

const PLACEHOLDER_PREFIX = 'TODO_';

export function isAppLovinPlaceholder( value: string ): boolean
{
  return !value || value.startsWith( PLACEHOLDER_PREFIX );
}

export function resolveAppLovinValue( value: string ): string
{
  return isAppLovinPlaceholder( value ) ? '' : value;
}
